import React from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';

// components
import { Typography, Icon } from '@americanexpress/aqx-components';
import { StrikethroughOffer } from 'src/universal/components/Strikethrough';
import Ribbon, { POSITIONS } from './Ribbon';

// selectors
import {
  getCardTileDtm,
  makeGetOfferBadgeText,
  makeGetOfferContent,
  makeGetLearnMoreUrl,
  makeGetCardTitle,
  makeGetIsTier1Offer,
  makeGetIsTier2Offer,
  makeGetCardFeatureHeader,
  makeGetCardFeatureDescription
} from '../redux';
import { getPznInfo } from 'src/universal/redux/pznData.js';

// styles
import styles from '../__styles__/offer.scss?modules';

const DualOfferSeparator = () => (
  <div className={styles.separator}>
    <div className={styles.separatorLine} />
    <Icon
      className={styles.separatorIcon}
      directory="dls"
      imageName="dls-icon-plus-filled"
    />
    <div className={styles.separatorLine} />
  </div>
);

const Offer = ({
  offerContent,
  shortName,
  isTier1Offer,
  isTier2Offer,
  cardFeatureHeader,
  cardFeatureDescription,
  hasPznArrived
}) => {
  const {
    offerHeader,
    offerDescription,
    dualOfferHeader,
    dualOfferDescription
  } = offerContent;

  if (!offerHeader && !cardFeatureHeader) {
    return null;
  }

  return (
    hasPznArrived && (
      <div
        className={clsx(styles.container, {
          [styles.isVariant]: !isTier1Offer && isTier2Offer,
          [styles.isVariantTier1SpecialOffer]: isTier1Offer && isTier2Offer
        })}
      >
        <Ribbon position={POSITIONS.OFFER_BOX_RIBBON} shortName={shortName} />
        <StrikethroughOffer
          header={offerHeader ?? cardFeatureHeader}
          Component="h3"
          className={styles.header}
        />
        <Typography className={styles.description}>
          {offerDescription ?? cardFeatureDescription}
        </Typography>
        {dualOfferHeader && <DualOfferSeparator />}
        <StrikethroughOffer
          header={dualOfferHeader}
          Component="h3"
          className={styles.header}
        />
        {dualOfferDescription && (
          <Typography className={styles.description}>
            {dualOfferDescription}
          </Typography>
        )}
      </div>
    )
  );
};

const mapStateToProps = () => {
  const getOfferBadgeText = makeGetOfferBadgeText();
  const getOfferContent = makeGetOfferContent();
  const getCardTitle = makeGetCardTitle();
  const getIsTier1Offer = makeGetIsTier1Offer();
  const getIsTier2Offer = makeGetIsTier2Offer();
  const getCardFeatureHeader = makeGetCardFeatureHeader();
  const getCardFeatureDescription = makeGetCardFeatureDescription();
  const getLearnMoreUrl = makeGetLearnMoreUrl();
  return (state, { shortName }) => ({
    dtmEvent: getCardTileDtm(state)?.offerPill?.dtm || {},
    offerBadgeText: getOfferBadgeText(state, shortName),
    offerContent: getOfferContent(state, shortName),
    learnMoreUrl: getLearnMoreUrl(state, shortName),
    cardTitle: getCardTitle(state, shortName),
    isTier1Offer: getIsTier1Offer(state, shortName),
    isTier2Offer: getIsTier2Offer(state, shortName),
    cardFeatureHeader: getCardFeatureHeader(state, shortName),
    cardFeatureDescription: getCardFeatureDescription(state, shortName),
    hasPznArrived: getPznInfo(state).hasPznArrived
  });
};

export default connect(mapStateToProps)(Offer);
